<template>
    <div class="h_search">
        <input type="text" class="h_search_text" placeholder="请输入要搜索的关键字" v-model="keyword">
        <input type="button" class="h_search_btn" value="" @click="toSearch()">
    </div>
</template>

<script>
    import {getQueryVariable} from "@/core/common"

    export default {
        name: "Search",
        data() {
            return {
                keyword: null
            }
        },
        mounted() {
            let keyword = getQueryVariable("keyword");
            if (keyword) {
                this.keyword = decodeURI(keyword);
            }
        },
        methods: {
            toSearch() {
                if (this.keyword !== "" && this.keyword !== null) {
                    window.location.href = 'qwss?keyword=' + this.keyword;
                } else {
                    window.location.href = 'qwss';
                }
            }
        }
    }
</script>

<style scoped>

</style>